import { render } from "./mentalHealthDetail.vue?vue&type=template&id=718eb25c&scoped=true"
import script from "./mentalHealthDetail.vue?vue&type=script&lang=js"
export * from "./mentalHealthDetail.vue?vue&type=script&lang=js"

import "./mentalHealthDetail.vue?vue&type=style&index=0&id=718eb25c&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718eb25c"]])

export default __exports__